import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import { AvlAnimationGmapComponent } from './avl-animation-gmap.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { default as pjson } from '../../../../../package.json';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatInputModule} from '@angular/material/input';

@NgModule({
  declarations: [
    AvlAnimationGmapComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        MatCheckboxModule,
        ComponentSetupModule,
        MatFormFieldModule,
        MatTooltipModule,
        MatInputModule,
    ],
  exports: [
    AvlAnimationGmapComponent
  ],
  providers: [
  ]
})

export class AvlAnimationGmapModule {
  constructor(private injector: Injector, private customElementService: CustomElementService ) {

    customElementService.convertToCustomElement(AvlAnimationGmapComponent, 'sc-avl-animation-gmap', this.injector, pjson.version);
  }
}
